// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import api from '../../../../../../../services/api';

const getBookshopCustomer = async (data) => {
  return api(
    '/Sellitback.svc/GetBookshopCustomer',
    data,
    'POST'
  );
};

const redeemVoucher = async (data) => {
  return api(
    '/Sellitback.svc/RedeemVoucher',
    data,
    'POST'
  );
};

const getBalanceWithdrawalLogs = async (data) => {
  return api(
    '/Sellitback.svc/GetBalanceWithdrawalLogs',
    data,
    'POST'
  );
};

export {
  getBookshopCustomer,
  getBalanceWithdrawalLogs,
  redeemVoucher
};
